// import { leaseType,repaymentMethodList } from '@/util/dictList.js'
import store from "@/store";
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      display: false,
      search: true,
      searchOrder: 666,
    },
    {
      label: '姓名',
      prop: 'name',
      type: 'input',
      search: true,
      display: false,
      searchOrder: 777,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      span: 24,
      display: false,
    },
    {
      label: "所属代理商",
      prop: "businessDeptIdList",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      hide: true,
      dicData: [],
      searchOrder: 999,
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: '产品类型',
      prop: 'rentTypeStr',
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'select',
      display: false,
      search: true,
      showColumn: false,
      searchMultiple: true,
      hide: true,
      dicData: store.getters.porductTypes,
      searchOrder: 888,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      // search: true,
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      span: 24,
      display: false,
    },
  ],
};

// 费用明细
export const feeTypeOption=[
  {
    title: '垫付过户税费',
    type: 1,
    value:''
  },
  {
    title: '垫付违章年检',
    type: 2,
    value:''
  },
  {
    title: '垫付拖车成本',
    type: 3,
    value:''
  },
  {
    title: '垫付刑案其他费用',
    type: 4,
    value:''
  },
  {
    title: '垫付代理费',
    type: 5,
    value:''
  },
  {
    title: '垫付诉讼费',
    type: 6,
    value:''
  },
  {
    title: '垫付差旅费',
    type: 7,
    value:''
  },
  {
    title: '垫付诉讼其他费用',
    type: 8,
    value:''
  },
]
